<section>
  <h1>Reset Password</h1>
  <p *ngIf="!authenticationCodeSent">
    To reset your password, enter the <strong>email you registered with</strong> below and we will send you an
    authentication code at that address.  You will need it to complete your password reset process.
  </p>

  <form *ngIf="!authenticationCodeSent" (submit)="sendAuthenticationCode()">
    <mat-form-field>
      <mat-label>Email Address</mat-label>
      <input matInput
             type="text"
             required
             name="email"
             [(ngModel)]="forgotPasswordForm.email">
    </mat-form-field>

    <div class="action-buttons">
      <button type="submit" mat-flat-button color="primary">Send Authentication Code</button>
    </div>
  </form>

  <p *ngIf="authenticationCodeSent">
    Your authentication code will be provided to the email address entered shortly.  It can take <strong>up to 2 minutes</strong>
    to generate so please be patient.  Once received, enter the code below to complete your password reset process.
  </p>

  <form *ngIf="authenticationCodeSent" (submit)="savePasswordChange()">
    <mat-form-field>
      <mat-label>Authentication Code</mat-label>
      <input matInput
             type="text"
             required
             minlength="6"
             [defaultValue]=""
             name="forgotPasswordSecret"
             autocomplete="one-time-code"
             [(ngModel)]="resetPasswordForm.forgotPasswordSecret">
    </mat-form-field>
    <mat-form-field>
      <mat-label>New Password</mat-label>
      <mbnm-password-revealer>
        <input matInput
               type="password"
               required
               minlength="6"
               name="new"
               autocomplete="new-password"
               [defaultValue]=""
               [(ngModel)]="resetPasswordForm.new">
      </mbnm-password-revealer>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Confirm Password</mat-label>
      <mbnm-password-revealer>
        <input matInput
               type="password"
               required
               minlength="6"
               name="confirm"
               autocomplete="new-password"
               [defaultValue]=""
               [(ngModel)]="resetPasswordForm.confirm">
      </mbnm-password-revealer>
    </mat-form-field>

    <div class="action-buttons">
      <button type="submit" mat-flat-button color="primary">Reset Password</button>
    </div>
  </form>

  <p *ngIf="authenticationCodeSent">
    Please remember that the <strong>authentication code expires after 10 minutes</strong>.  You can request a new
    code if yours expires by clicking the button below after a short wait.
    <br /><br />
    <button type="button" (click)="sendAuthenticationCode()" [disabled]="resendCodeDisableTime > 0" mat-flat-button color="secondary">
      <ng-container *ngIf="resendCodeDisableTime > 0">Please Wait {{ resendCodeDisableTime }} Seconds</ng-container>
      <ng-container *ngIf="resendCodeDisableTime === 0">Request a New Code</ng-container>
    </button>
  </p>

</section>
